export default "__VITE_ASSET__2a73b08e__"